module.exports = __webpack_public_path__ + "img/l-cb6-r1.97f9ea88.gif";